// extracted by mini-css-extract-plugin
export default {"page":"T2-z","cartModal":"U2-z","checkout":"V2-z","placeholder":"W2-z","account":"X2-z"};